/**
 * Datepicker field can have the following rules, which affect style and functionality (admin app):
 * - RequiredIf - set * after the label
 * - EnableIf - set both input field and label to disabled, when False
 * - ReadOnlyIf - set both input field and label to readOnly
 */

import { Component, ViewChild, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { selectMessagesForOpenedEditorForProperty } from 'src/app/project/store/project-data/project-data.selectors';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import type { TreeEntity } from '../../../core/models/entity.model';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';

@Component({
  selector: 'app-entity-property-datepicker',
  templateUrl: './entity-property-datepicker.component.html',
  styleUrls: ['./entity-property-datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertyDatepickerComponent extends EntityPropertyBaseComponent<Date> implements OnChanges {
  @ViewChild('picker') datePicker: MatDatepicker<any>;

  messages: TreeEntity[] = [];

  messagesForOpenedEditorForProperty$ = (key: string) => this.store.select(selectMessagesForOpenedEditorForProperty(key, this.entityId));

  constructor(private store: Store) {
    super();
    this.messagesForOpenedEditorForProperty$ = (propertyKey: string) =>
      this.store.select(selectMessagesForOpenedEditorForProperty(this.property.Key, this.entityId)).pipe(take(1));
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['property']) {
      this.messagesForOpenedEditorForProperty$(this.property.Key)
        .pipe(take(1))
        .subscribe(msgs => (this.messages = msgs));
    }
  }

  onInputClick() {
    this.datePicker.open();
  }

  reset() {
    this.propertyForm.reset();
    this.datePicker.close();
  }
}
